import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { sportsEloHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/eloInfo';
import { useContext, useMemo } from 'react';

const MatchPredication = ({ match }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { teams_info, details_info } = sportsSeason_state ?? {};
  const { teams } = teams_info ?? {};
  const { details } = details_info ?? {}

  const predictors = (prediction) => {
    const { confidence, confidenceColor, favoriteTeam } = prediction ?? {}
    return <div className={`match-pred`}>
      <div>{'ELO Prediction'}</div>
      <div>{`${confidence} 👉 (${favoriteTeam?.name})`}</div>
      <div>{`${favoriteTeam?.prob}%`}</div>
      {/* <Label size='tiny' >
        {`ELO Prediction 👉 ${favoriteTeam?.name} - ${confidence} (${favoriteTeam?.prob}%) `}
      </Label> */}
    </div>
  }

  const { predictor, hasPrediction } = useMemo(() => {
    const prediction = sportsEloHelpers.getMatchPrediction({ match, teams })
    if (!prediction) return { predictor: null, hasPrediction: false };
    return {
      predictor: predictors(prediction),
      hasPrediction: true
    }
  }, [match?._itemKey])

  return hasPrediction ? predictor : null
}

export default MatchPredication